import { __decorate } from "tslib";
import { attr, html, observable, slotted, when } from '@microsoft/fast-element';
import { ChameleonElementMixin } from '../common/mixin';
import { SVG_CLOSE_OUTLINED, SVG_PERSON_OUTLINED } from '@getgo/chameleon-icons';
import { FoundationElement } from '@microsoft/fast-foundation';
export const chipTemplate = html `<template role="button" tabindex="0" @click=${(x) => x.action()}>
  ${when((x) => x.person, () => html `<chameleon-svg class="person-icon">${SVG_PERSON_OUTLINED}</chameleon-svg>`)}
  <slot ${slotted('slottedAvatar')} name="avatar"></slot>
  <slot></slot>
  ${when((x) => x.closable, () => html `<span class="close" @click=${(x, { event }) => x.close(event)}
      ><chameleon-svg>${SVG_CLOSE_OUTLINED}</chameleon-svg></span
    >`)}
</template>`;
export class ChipComponent extends ChameleonElementMixin(FoundationElement) {
    constructor() {
        super(...arguments);
        this.size = 'medium';
        this.handleKeyDown = (event) => {
            const { key } = event;
            if (key === ' ' || key === 'enter') {
                this.action();
                event.preventDefault();
            }
        };
    }
    sizeChanged(_, newValue) {
        var _a;
        if (this.slottedAvatar && ((_a = this.slottedAvatar) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            this.slottedAvatar.forEach((avatar) => {
                avatar.setAttribute('size', `${newValue}`);
                if (newValue === null) {
                    avatar.setAttribute('size', `medium`);
                }
            });
        }
    }
    disabledChanged(_, newValue) {
        requestAnimationFrame(() => {
            var _a;
            if (this.slottedAvatar && ((_a = this.slottedAvatar) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                this.slottedAvatar.forEach((avatar) => {
                    avatar.setAttribute('disabled', `${newValue}`);
                    if (newValue === null) {
                        avatar.setAttribute('disabled', `medium`);
                    }
                });
            }
        });
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('keydown', this.handleKeyDown);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('keydown', this.handleKeyDown);
    }
    slottedAvatarChanged(_, newValue) {
        if (newValue && newValue.length > 0) {
            this.setAttribute('has-avatar', 'true');
            newValue.forEach((avatar) => {
                avatar.setAttribute('size', `${this.size}`);
                if (this.getAttribute('disabled')) {
                    avatar.setAttribute('disabled', '');
                }
            });
        }
        else {
            this.removeAttribute('has-avatar');
        }
    }
    action() {
        if (this.disabled)
            return;
        this.$emit('chip-action', null, { bubbles: true });
    }
    close(event) {
        if (this.disabled)
            return;
        event.stopPropagation();
        this.$emit('close', null, { bubbles: true });
    }
}
__decorate([
    attr({ mode: 'boolean' })
], ChipComponent.prototype, "selected", void 0);
__decorate([
    attr({ mode: 'boolean' })
], ChipComponent.prototype, "disabled", void 0);
__decorate([
    attr({ mode: 'boolean' })
], ChipComponent.prototype, "active", void 0);
__decorate([
    attr({ mode: 'boolean' })
], ChipComponent.prototype, "error", void 0);
__decorate([
    attr({ mode: 'boolean' })
], ChipComponent.prototype, "closable", void 0);
__decorate([
    attr({ mode: 'boolean' })
], ChipComponent.prototype, "person", void 0);
__decorate([
    attr
], ChipComponent.prototype, "size", void 0);
__decorate([
    observable
], ChipComponent.prototype, "slottedAvatar", void 0);
